import { CSSProperties } from 'react';
import styled, { Interpolation } from 'styled-components';

export const percentageOfSize =
  (total = 12) =>
  (size: number) =>
    `${(size / total) * 100}%`;

const TableRoot = styled.table<{
  styles?: Interpolation<CSSProperties>;
}>`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  ${({ styles }) => styles}
`;

const Cell = styled.td<{
  size?: number | `${number}`;
  width?: CSSProperties['width'];
  padded?: boolean;
  align?: CSSProperties['textAlign'];
  ellipsis?: boolean;
  styles?: Interpolation<CSSProperties>;
  wordBreak?: CSSProperties['wordBreak'];
}>`
  ${({ size }) => size && `width: ${percentageOfSize()(Number(size))};`}
  ${({ width }) => width && `width: ${width};`}
  ${({ padded = true }) => padded && `padding: 8px 16px;`}
  ${({ align }) => align && `text-align: ${align};`}
  ${({ ellipsis }) =>
    ellipsis && `max-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;`}
  ${({ wordBreak }) => wordBreak && `word-break: ${wordBreak};`}
  ${({ styles }) => styles}
`;

const Header = styled.thead<{ styles?: Interpolation<CSSProperties> }>`
  ${({ styles }) => styles}

  ${Cell} {
    word-break: keep-all;
  }
`;

const Body = styled.tbody<{ styles?: Interpolation<CSSProperties> }>`
  ${({ styles }) => styles}
`;

const Row = styled.tr<{ noBorder?: boolean; styles?: Interpolation<CSSProperties> }>`
  ${({ noBorder = false }) => !noBorder && `border-bottom: 1px solid #e8e8e8;`}
  ${({ styles }) => styles}
`;

const Footer = styled.tfoot<{ padded?: boolean; styles?: Interpolation<CSSProperties> }>`
  ${({ padded = true }) => padded && `padding: 8px 16px;`}
  ${({ styles }) => styles}
`;

const Table = Object.assign(TableRoot, { Header, Body, Row, Cell, Footer });

export default Table;
